// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Gmail = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Gmail = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Gmail = _exports.Gmail = function Gmail(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1.36364 18.0038H4.54545V9.76136L0 6.125V16.5492C0 17.3541 0.611364 18.0038 1.36364 18.0038Z",
      fill: "#4285F4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.4531 18.0038H18.6349C19.3895 18.0038 19.9986 17.3517 19.9986 16.5492V6.125L15.4531 9.76136",
      fill: "#34A853"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.4531 3.45867V9.7617L19.9986 6.12534V4.18594C19.9986 2.38716 18.0736 1.3617 16.7259 2.44049",
      fill: "#FBBC04"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.54688 9.76201V3.45898L10.0014 7.82262L15.456 3.45898V9.76201L10.0014 14.1257",
      fill: "#EA4335"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M0 4.18594V6.12534L4.54545 9.7617V3.45867L3.27273 2.44049C1.92273 1.3617 0 2.38716 0 4.18594Z",
      fill: "#C5221F"
    }));
  };
});
